"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAllDict = exports.operationPersonnel = exports.areaRegion = exports.FlowStatus = exports.ApprovalStatus = exports.baseSwitch = void 0;
const complex_data_1 = require("complex-data");
const select_1 = __importDefault(require("../api/select"));
const config_1 = require("./config");
const ComplexSelect_1 = __importDefault(require("@/class/ComplexSelect"));
const option_1 = __importDefault(require("@/style/option"));
exports.baseSwitch = new complex_data_1.SelectList({
    name: '是否',
    list: [
        {
            value: '0',
            label: '否'
        },
        {
            value: '1',
            label: '是'
        },
    ]
});
exports.ApprovalStatus = new complex_data_1.SelectList({
    name: '审批状态',
    list: [
        {
            value: '1',
            label: '审批中',
            status: 'ing'
        },
        {
            value: '2',
            label: '通过',
            status: 'success'
        },
        {
            value: '9',
            label: '拒绝',
            status: 'fail'
        }
    ]
});
exports.FlowStatus = new complex_data_1.SelectList({
    name: '流程状态',
    list: [
        {
            value: '1',
            label: '正常',
            status: 'normal'
        },
        {
            value: '2',
            label: '退回',
            status: 'refuse',
            color: option_1.default.color.danger
        },
        {
            value: '3',
            label: '驳回',
            status: 'reject',
            color: option_1.default.color.warn
        },
        {
            value: '4',
            label: '委派',
            status: 'normal'
        },
        {
            value: '5',
            label: '转办',
            status: 'normal'
        },
        {
            value: '6',
            label: '终止',
            status: 'end'
        },
        {
            value: '7',
            label: '未操作',
            status: 'normal'
        }
    ]
});
exports.areaRegion = new ComplexSelect_1.default({
    name: '区域列表',
    list: [],
    getData() {
        return new Promise((resolve, reject) => {
            select_1.default.areaRegion.require().then(res => {
                const list = res.data.data.map(item => {
                    return {
                        value: item.id,
                        label: item.areaName
                    };
                });
                resolve({ status: 'success', list: list });
            }).catch(err => {
                reject(err);
            });
        });
    }
});
exports.operationPersonnel = new ComplexSelect_1.default({
    name: '运营人员',
    list: [],
    getData() {
        return (0, config_1.loadDefaultDictList)(select_1.default.operationPersonnel);
    }
});
const loadAllDict = function () {
    return Promise.allSettled([exports.areaRegion.$loadData(), exports.operationPersonnel.$loadData()]);
};
exports.loadAllDict = loadAllDict;
